<div class="chart-message">
  <div class="chart-title">{{ title }}</div>

  <div *ngIf="isEmpty" class="chart-empty">
    No data was available to plot for this request.
  </div>

  <div
    *ngIf="!isEmpty"
    echarts
    [options]="option"
    class="chart-canvas"
  ></div>

  <div *ngIf="notes?.length" class="chart-notes">
    <div *ngFor="let note of notes" class="chart-note">{{ note }}</div>
  </div>
</div>
